import React from 'react';
import { Modal, Button, } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { UnstyledTextAreaField } from '../common/Inputs'


let SpecialOrderConfirmModal = props => {
    const { onConfirmed, onCanceled, show, comment, title } = props;

    return (
        <Modal show={show} >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Field name="Comment" component={UnstyledTextAreaField} />
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="success" type="button" onClick={onConfirmed} disabled={!comment}>Подтвердить</Button>
                <Button type="button" onClick={onCanceled}>Отмена</Button>
            </Modal.Footer>
        </Modal>
    )
};

SpecialOrderConfirmModal = connect((state, props) => ({
    comment: (getFormValues(props.formName)(state)).Comment
}))(SpecialOrderConfirmModal);

export default SpecialOrderConfirmModal;


// WEBPACK FOOTER //
// ./src/components/orders/SpecialOrderConfirmModal.jsx